var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3011_7332)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96875 5.85938C3.31393 5.85938 3.59375 6.1392 3.59375 6.48438V18.7891C3.59375 19.1342 3.31393 19.4141 2.96875 19.4141C2.62357 19.4141 2.34375 19.1342 2.34375 18.7891V6.48438C2.34375 6.1392 2.62357 5.85938 2.96875 5.85938Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.768996 16.5893C1.01307 16.3452 1.4088 16.3452 1.65288 16.5893L2.96875 17.9052L4.28462 16.5893C4.5287 16.3452 4.92443 16.3452 5.1685 16.5893C5.41258 16.8334 5.41258 17.2291 5.1685 17.4732L3.41069 19.231C3.16661 19.4751 2.77089 19.4751 2.52681 19.231L0.768996 17.4732C0.524918 17.2291 0.524918 16.8334 0.768996 16.5893Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52681 6.04243C2.77089 5.79836 3.16661 5.79836 3.41069 6.04243L5.1685 7.80025C5.41258 8.04432 5.41258 8.44005 5.1685 8.68413C4.92443 8.92821 4.5287 8.92821 4.28462 8.68413L2.96875 7.36826L1.65288 8.68413C1.4088 8.92821 1.01307 8.92821 0.768996 8.68413C0.524918 8.44005 0.524918 8.04432 0.768996 7.80025L2.52681 6.04243Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85938 2.96875C5.85938 2.62357 6.1392 2.34375 6.48438 2.34375H18.7891C19.1342 2.34375 19.4141 2.62357 19.4141 2.96875C19.4141 3.31393 19.1342 3.59375 18.7891 3.59375H6.48438C6.1392 3.59375 5.85938 3.31393 5.85938 2.96875Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68413 0.768996C8.92821 1.01307 8.92821 1.4088 8.68413 1.65288L7.36826 2.96875L8.68413 4.28462C8.92821 4.5287 8.92821 4.92443 8.68413 5.1685C8.44005 5.41258 8.04432 5.41258 7.80025 5.1685L6.04243 3.41069C5.79836 3.16661 5.79836 2.77089 6.04243 2.52681L7.80025 0.768996C8.04432 0.524918 8.44005 0.524918 8.68413 0.768996Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5893 0.768996C16.8334 0.524918 17.2291 0.524918 17.4732 0.768996L19.231 2.52681C19.4751 2.77089 19.4751 3.16661 19.231 3.41069L17.4732 5.1685C17.2291 5.41258 16.8334 5.41258 16.5893 5.1685C16.3452 4.92443 16.3452 4.5287 16.5893 4.28462L17.9052 2.96875L16.5893 1.65288C16.3452 1.4088 16.3452 1.01307 16.5893 0.768996Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86719 12.9688V18.1641H12.8906V12.9688H8.86719ZM7.91466 12.0162C8.10512 11.8258 8.36345 11.7188 8.63281 11.7188H13.125C13.3944 11.7188 13.6527 11.8258 13.8432 12.0162C14.0336 12.2067 14.1406 12.465 14.1406 12.7344V18.7891C14.1406 19.1342 13.8608 19.4141 13.5156 19.4141H8.24219C7.89701 19.4141 7.61719 19.1342 7.61719 18.7891V12.7344C7.61719 12.465 7.72419 12.2067 7.91466 12.0162Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9016 7.38593C11.1286 7.15883 11.4367 7.03125 11.7578 7.03125H17.0312C17.3524 7.03125 17.6604 7.15883 17.8875 7.38593C18.1146 7.61302 18.2422 7.92103 18.2422 8.24219V18.7891C18.2422 19.1342 17.9624 19.4141 17.6172 19.4141H13.5156C13.1704 19.4141 12.8906 19.1342 12.8906 18.7891C12.8906 18.4439 13.1704 18.1641 13.5156 18.1641H16.9922V8.28125H11.7969V12.3438C11.7969 12.6889 11.5171 12.9688 11.1719 12.9688C10.8267 12.9688 10.5469 12.6889 10.5469 12.3438V8.24219C10.5469 7.92103 10.6745 7.61302 10.9016 7.38593Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44531 18.7891C6.44531 18.4439 6.72513 18.1641 7.07031 18.1641H8.24219C8.58737 18.1641 8.86719 18.4439 8.86719 18.7891C8.86719 19.1342 8.58737 19.4141 8.24219 19.4141H7.07031C6.72513 19.4141 6.44531 19.1342 6.44531 18.7891Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9922 18.7891C16.9922 18.4439 17.272 18.1641 17.6172 18.1641H18.7891C19.1342 18.1641 19.4141 18.4439 19.4141 18.7891C19.4141 19.1342 19.1342 19.4141 18.7891 19.4141H17.6172C17.272 19.4141 16.9922 19.1342 16.9922 18.7891Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5469 14.6875C10.5469 14.3423 10.8267 14.0625 11.1719 14.0625H13.5156C13.8608 14.0625 14.1406 14.3423 14.1406 14.6875C14.1406 15.0327 13.8608 15.3125 13.5156 15.3125H11.1719C10.8267 15.3125 10.5469 15.0327 10.5469 14.6875Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2344 10C15.2344 9.65482 15.5142 9.375 15.8594 9.375H17.6172C17.9624 9.375 18.2422 9.65482 18.2422 10C18.2422 10.3452 17.9624 10.625 17.6172 10.625H15.8594C15.5142 10.625 15.2344 10.3452 15.2344 10Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2344 12.3438C15.2344 11.9986 15.5142 11.7188 15.8594 11.7188H17.6172C17.9624 11.7188 18.2422 11.9986 18.2422 12.3438C18.2422 12.6889 17.9624 12.9688 17.6172 12.9688H15.8594C15.5142 12.9688 15.2344 12.6889 15.2344 12.3438Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3011_7332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.13eb63e4cf5e2c8633e214d63c547eb1.svg";
export { ForwardRef as ReactComponent };